import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { ESystemAccess, ESystemProfileList } from 'src/app/enum/EAccess';
import { SessionService } from 'src/app/shared/services/session.service';
import { AdministracionCarteraApiService } from '../services/administracion-cartera-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Bag, BagResponse } from '../models/bag';

@Component({
    selector: 'app-admin-cartera-edit',
    templateUrl: './admin-cartera-edit.component.html',
    styleUrls: ['./admin-cartera-edit.component.scss']
})
export class AdminCarteraEditComponent {
    private readonly access: string[] = [
        ESystemAccess.ADMINISTRACION_CARTERA,
        ESystemProfileList.WEB
    ];

    private MAX_FILE_SIZE = 1000000 as const;

    public detail: BagResponse | null = null;

    public bagForm!: FormGroup;
    public fileName = '';

    public formLoading = false;
    public isBagDataLoading = true;

    constructor(
        private fb: FormBuilder,
        private alertsService: AlertService,
        private _apiService: AdministracionCarteraApiService,
        private _router: Router,
        private _session: SessionService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        if (!this.checkAccess()) {
            this._router.navigate(['/request-access'])
            return;
        }

        this.bagForm = this.fb.group({
            name: [{value: '', disabled: true}],
            file: ['']
        })

        this._route.paramMap.subscribe(params => {
            const bagID = params.get('id');

            if (!bagID) return;

            this.getBagData(bagID);
        });
    }

    getBagData(id: string): void {
        this.isBagDataLoading = true;
        this._apiService.getBagDetail(id).subscribe({
            next: (res) => {
                this.detail = res;
                const nameControl = this.bagForm.get('name');

                nameControl?.setValue(res.name);
                nameControl?.enable();

                this.isBagDataLoading = false;
            },
            error: () => {
                this.alertsService.error("Ocurrió un error al obtener los datos de la cartera.");
                this.isBagDataLoading = false;
            }
        })
    }

    checkAccess(): boolean {
        const hasAdminCarteraPermission = this._session.getUserAccess().includes(this.access[0]);
        const hasWebProfile = this._session.getUserProfileList().includes(this.access[1]);

        return hasAdminCarteraPermission && hasWebProfile;
    }

    handleUpload(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (!file) return;

        if (file.size > this.MAX_FILE_SIZE) {
            this.alertsService.error('El tamaño del archivo no puede ser mayor a 1 MB.');
            return;
        }

        this.fileName = file.name;

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            const file = reader?.result?.toString().split(',')[1];
            const fileControl = this.bagForm.get('file');

            fileControl?.setValue(file);
        };
    }

    submitArchivo() {
        this.formLoading = true;

        if (!this.detail?.id) {
            this.alertsService.error("No se encontró la cartera a editar.");
            this.formLoading = false;
            return;
        }

        const fileControl = this.bagForm.get('file');
        if (typeof fileControl?.value !== 'string') {
            this.alertsService.error('Ocurrió un error con el archivo.');
            this.formLoading = false;
            return;
        }

        const nameControl = this.bagForm.get('name');
        const idOrganizacion = this._session.getOrganization();
        const idUsuario = this._session.getUserInfo().username;
        let name = nameControl?.value;
        if (name == '') {
            name = 'Cartera ' + idOrganizacion + ' ' + new Date().getTime()
        }

        const bag: Bag = {
            name: name,
            description: idOrganizacion + ' ' + idUsuario,
        }

        if (fileControl?.value != '') {
            bag.base64Content = fileControl?.value;
        }

        this._apiService.updateBag(bag, this.detail.id).subscribe({
            next: (res) => {
                if (!res.bagId) {
                    this.alertsService.error("Ocurrió un error al intentar actualizar la cartera.")
                    this.formLoading = false
                    return;
                }

                this._router.navigate(['/administracion-cartera-detalle', res.bagId])
                this.alertsService.success(res?.message || "Cartera actualizada exitosamente.");
            },
            error: ({error}) => {
                this.alertsService.error(error?.message || "Ocurrió un error al intentar actualizar la cartera.")
                this.formLoading = false
            }
        })

    }

    goBack() {
        this._router.navigate(['/administracion-cartera-detalle', this.detail?.id])
    }
}
